module.exports = __webpack_public_path__ + "img/eye-cross-inactive.90cac68e.svg";